module.exports = __webpack_public_path__ + "img/sv4on.a3dbff6f.svg";